import React from 'react';
import { IconProps } from '../types';
const MinecraftGoldenHorseArmor: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="11" y="3" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(253, 255, 118, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(69, 5, 5, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(69, 5, 5, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(69, 5, 5, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(69, 5, 5, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(69, 5, 5, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(69, 5, 5, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(238, 224, 87, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(69, 5, 5, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(58, 4, 4, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(50, 4, 4, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(50, 4, 4, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(50, 4, 4, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(50, 4, 4, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(50, 4, 4, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(219, 162, 19, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(236, 203, 69, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(178, 100, 17, 255)" />
</svg>);
export default MinecraftGoldenHorseArmor;